import type { ZoomUserContextStatus } from './zoomAccess';

interface AuthorizeBannerProps {
  userContextStatus: ZoomUserContextStatus;
  onAuthorize: () => void;
  authorizing: boolean;
}

export function AuthorizeBanner({
  userContextStatus,
  onAuthorize,
  authorizing,
}: AuthorizeBannerProps) {
  if (userContextStatus === 'authorized') {
    return null;
  }

  const message =
    userContextStatus === 'authenticated'
      ? 'Sign in with Zoom and add this app to connect to the relay.'
      : 'Sign in to Zoom and add this app to connect to the relay.';

  return (
    <div className="banner banner-info authorize-banner">
      <p className="authorize-banner-text">{message}</p>
      <button
        type="button"
        className="authorize-banner-btn"
        onClick={onAuthorize}
        disabled={authorizing}
      >
        {authorizing ? 'Waiting for Zoom…' : 'Sign in / add app'}
      </button>
    </div>
  );
}
